






import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Sku} from "../models";

@Component
export default class SkuImage extends Vue {
    @Prop()
    sku!: Sku;
    get alt(): string {
        return `Card image for ${this.sku.name}`
    }

}
